import { render, staticRenderFns } from "./WorkspaceSkillsTab.vue?vue&type=template&id=17dfd230&"
import script from "./WorkspaceSkillsTab.vue?vue&type=script&lang=js&"
export * from "./WorkspaceSkillsTab.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceSkillsTab.vue?vue&type=style&index=0&id=17dfd230&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports